import { atom } from "recoil";

export const notifications = atom({
  key: 'notifications',
  default: 0,
});